export default "__VITE_ASSET__BDsLfKOI__"